import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
  margin-right: 20px;
  align-self: flex-end;
`

export const Text = styled.div`
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  font-size: small;
  color: gray;
  margin-bottom: 10px;
`

export const Flag = styled.img`
  width: 90px;
  height: 64px;
  margin: 5px 10px 5px 10px;
  border: 0;
  padding: 12px;
`
